import { Component, Input } from '@angular/core';
import { TranslocoService, TranslocoPipe } from '@jsverse/transloco';
import { ExtendedOrderType } from '../../../core/enums';
import { SearchResult } from '../../../core/models';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-category-popover',
    standalone: true,
    imports: [RouterLink, TranslocoPipe],
    templateUrl: './category-popover.component.html',
    styleUrls: ['./category-popover.component.css'],
})
export class CategoryPopoverComponent {
  @Input() category: SearchResult;

	ExtendedOrderType = ExtendedOrderType;

  constructor(public translate: TranslocoService) { }
}
